module.exports = __webpack_public_path__ + "img/coffee.11e46cbe.svg";